module.exports = {"420112001":"吴家山街道","420112002":"柏泉街道","420112004":"将军路街道","420112005":"慈惠街道","420112006":"走马岭街道","420112007":"径河街道","420112008":"长青街道","420112011":"辛安渡街道","420112012":"东山街道","420112013":"常青花园新区街道管理委员会","420112014":"新沟镇街道","420112015":"金银湖街道","420112400":"产业管理处","420112401":"保税物流管理处","420112402":"海峡两岸科技产业管理处","420112403":"食品工业管理处","420112404":"临空经济管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420112.json
// module id = 1556
// module chunks = 0